import { Injectable } from "@angular/core";

import { CoreState } from "../../state";

import { RealityCheckData, RealityCheckState } from "./reality-check.model";

@Injectable({
	providedIn: "root",
})
export class RealityCheckSelector {
	getState() {
		return (state: CoreState): RealityCheckState => state.realityCheck;
	}

	isGlobalRealityCheckEnabled() {
		return (state: CoreState): boolean => !!state.realityCheck.isGlobalRealityCheckEnabled;
	}

	lastRealityCheck() {
		return (state: CoreState): RealityCheckData | undefined => state.realityCheck.lastRealityCheck;
	}
	nextPulse() {
		return (state: CoreState): number | undefined => state.realityCheck.nextPulse;
	}

	triggeredAt() {
		return (state: CoreState): number | undefined => state.realityCheck.triggeredAt;
	}
}
